import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import { isMobileDevice } from "../../utils";
import Product from "../../components/home/Product";
import { useNavigate } from "react-router";
import { productConceptDetail } from "../../API";
import { getQueryParam } from "../../utils/getUrlParamsLegacy";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [swiperRef, setSwiperRef]: any = useState(null);
  const [swiperIndex, setSwiperIndex] = useState(0);
  const navigate = useNavigate()

  const [detail, setDetail] = useState<any>(null)
  const handleLoad = () => {
    productConceptDetail(getQueryParam("id")).then(res => {
      setDetail(res.data)
    }).catch(err => {
      console.log(err)
    })
  }
  useEffect(() => {
    handleLoad()
  }, [])

  return (
    <div className="">
      <TopBar />
      <div className=" w-[1200px] mx-auto h5:w-full">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4 cursor-pointer" onClick={() => navigate('/exhibit')}>詩肯概念展示</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">{detail?.title}</div>
        </div>
        <div className="flex pb-[150px] h5:block h5:pb-[60px]">
          <div className="w-[770px] h5:w-full h5:px-16">
            <img src={detail?.materialImgUrls[swiperIndex]}
              className="w-full h-[433px] mb-[45px] rounded-md object-cover h5:h-[216px] h5:mb-[20px]"
              alt="" />
            <div className="relative px-[30px] h5:px-20">
              <Swiper
                spaceBetween={isMobileDevice() ? 26 : 36}
                ref={swiperRef}
                onSwiper={setSwiperRef}
                onSlideChange={(swiper: any) => {
                  setSwiperIndex(swiper.activeIndex);
                }}
                slidesPerView={isMobileDevice() ? 3 : 5}
                centeredSlides={false}
                speed={200}
                className=""
              >
                {detail?.materialImgUrls.map((item: any, index: any) => (
                  <SwiperSlide key={index}>
                    <img src={item}
                      onClick={() => {
                        setSwiperIndex(index);
                      }}
                      className="w-full h-[83px] object-cover h5:h-[66px]"
                      alt="" />
                  </SwiperSlide>
                ))
                }
              </Swiper>
              <div  >
                <div className={`${swiperIndex === 0 ? 'opacity-20' : 'opacity-60'} cursor-pointer absolute top-[36%] left-[0px] z-[10] h5:left-[-6px]`}
                  onClick={() => {
                    swiperRef.slideTo(swiperIndex === 0 ? 0 : swiperIndex - 1);
                  }}>
                  <img src={require('../../assets/image/icon1.png')} alt=""
                    className='w-[20px] rotate-[180deg]'
                  />
                </div>
                <div className={`${swiperIndex === 2 ? 'opacity-20' : 'opacity-60'} cursor-pointer absolute top-[36%] right-[0px] z-[10] h5:right-[-6px]`}
                  onClick={() => {
                    swiperRef.slideTo(swiperIndex === 2 ? 2 : swiperIndex + 1);
                  }}>
                  <img src={require('../../assets/image/icon1.png')} alt=""
                    className='w-[20px] rotate-[0deg]'
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="w-[30px]"></div>
          <div className="w-[370px]  h5:w-full h5:px-16 h5:mt-[30px]">
            <div className="text-[#3c342e] text-[46px] font-bold mb-[30px] h5:text-[30px] h5:mb-[15px]">{detail?.title}</div>
            <div className="">
              <div className="text-[#595959] text-[18px] h5:text-[16px]">{detail?.description}</div>
            </div>
            <div className="h5:flex h5:justify-center">
              <div className="hover:bg-[#000] hover:text-[#fff] cursor-pointer mt-[50px]
            inline-block py-15 px-[100px] rounded-md text-[#6d6e71] text-[18px] h5:py-10 h5:px-[50px]"
                onClick={() => navigate('/exhibit')}
                style={{
                  border: '2px solid #6d6e71'
                }}>
                ←
                回到列表
              </div>
            </div>
          </div>
        </div>
        <div className="mb-[60px] text-center text-[#181512] text-[40px] font-bold">靈魂主角</div> 
        {
          <Product productList={detail?.products} />
        }
        <div className="h-[75px] h5:h-[50px]"></div>
      </div>
      <Footer />
    </div>
  );
};

export default ComponentName;
